export default {
  loading: 'Caricamento prezzi…',
  default_modal: {
    title: 'Listino prezzi predefinito',
    description:
      'I prezzi di riserva che ogni partner senza override personalizzato eredita. Le modifiche non influiscono sulle licenze attive.',
    saved: 'Listino prezzi predefinito salvato.',
  },
  buttons: {
    edit: 'Modifica',
    cancel: 'Annulla',
    save: 'Salva',
  },
  toasts: {
    load_error: 'Impossibile caricare i dati sui prezzi.',
    save_error: 'Impossibile salvare — riprova.',
    prices_saved: 'Listino prezzi salvato.',
    license_created: 'Licenza creata.',
    lifecycle: {
      pause: 'Licenza sospesa.',
      resume: 'Licenza ripresa.',
      cancel: 'Licenza annullata.',
    },
  },
  price_book: {
    title: 'Listino prezzi',
    read_only_notice:
      'I prezzi del partner sostituiscono il listino predefinito principale. Le licenze attive mantengono i prezzi bloccati.',
    editing_notice: 'Modifica — i nuovi prezzi si applicano solo alle licenze create da ora in poi.',
    columns: {
      service: 'Servizio',
      cost_price: 'Prezzo lordo ({{currency}}/mese, IVA incl.)',
    },
    add_ons: 'Componenti aggiuntivi',
    missing_price: '{{name}} è abilitato ma non ha un prezzo — impostane uno o disabilitalo.',
    incomplete_tier:
      '{{name}} richiede sia un prezzo a volume sia il numero di sedi attive da cui si applica, oppure nessuno dei due.',
    invalid_tier:
      'Il prezzo a volume di {{name}} deve essere inferiore al prezzo standard, a partire da almeno 2 sedi attive.',
    tier: {
      from: 'Prezzo a volume da',
      live_locations: 'sedi attive',
      counted_one: 'Questo partner conta {{count}} sede con licenza attiva ai fini del prezzo a volume.',
      counted_other: 'Questo partner conta {{count}} sedi attive con licenza ai fini del prezzo a volume.',
    },
    snapshot_note:
      'I prezzi vengono bloccati su una licenza alla creazione — modificare il listino non cambia le licenze attive.',
    types: {
      base: 'Base',
      add_on: 'Componente aggiuntivo',
    },
  },
  volume_discount: {
    title: 'Sconto volume',
    read_only_notice:
      'Quando una fattura mensile raggiunge la soglia di licenze, lo sconto viene applicato a tutti i canoni di licenza del ciclo.',
    editing_notice: 'Modifica — le nuove impostazioni si applicano dal prossimo ciclo di fatturazione.',
    threshold_label: 'Soglia licenze',
    percent_label: 'Sconto',
    invalid: 'Inserisci una soglia di almeno 1 e uno sconto tra 0 e 100%.',
    saved: 'Sconto volume salvato.',
    note: 'Conta le licenze fatturate nel ciclo stesso; i mesi riportati sono esclusi. 0% (il valore predefinito) disattiva lo sconto, altrimenti si sommerebbe al prezzo a volume nel listino.',
  },
  licenses: {
    test_restaurant_unlicensable: 'Un ristorante di test non viene mai fatturato, quindi non può avere una licenza.',
    title: 'Licenze ristorante',
    select_company: 'Seleziona un ristorante',
    add_license: 'Aggiungi licenza',
    no_companies: 'Questo partner non ha ancora ristoranti.',
    no_licenses: 'Nessuna licenza per questo ristorante.',
    activated_at: 'Attiva dal',
    next_period_preview: 'Mese successivo (pro rata, prima dello sconto volume)',
    statuses: {
      active: 'Attiva',
      paused: 'Sospesa',
      canceled: 'Annullata',
    },
    columns: {
      product: 'Servizio',
      locked_price: 'Prezzo bloccato / mese',
      quantity: 'Qtà',
      trial_ends: 'Gratuito fino al',
    },
    price_tiers: {
      volume: 'Tariffa a volume',
      locked: 'Prezzo legacy',
    },
  },
  lifecycle: {
    pause: {
      action: 'Sospendi',
      title: 'Sospendere questa licenza?',
      description:
        'I giorni sospesi non vengono fatturati. La licenza mantiene i prezzi bloccati e può essere ripresa in qualsiasi momento.',
      confirm: 'Sospendi',
    },
    resume: {
      action: 'Riprendi',
      title: 'Riprendere questa licenza?',
      description: 'La fatturazione riprende da oggi ai prezzi bloccati.',
      confirm: 'Riprendi',
    },
    cancel: {
      action: 'Annulla licenza',
      title: 'Annullare questa licenza?',
      description:
        'Il mese corrente viene fatturato pro rata fino a oggi. Questa operazione non può essere annullata — una nuova licenza verrebbe creata ai prezzi di listino correnti.',
      confirm: 'Annulla licenza',
    },
  },
  add_license: {
    title: 'Aggiungi una licenza',
    description: 'Seleziona i servizi per questo ristorante. I prezzi vengono bloccati sulla licenza alla creazione.',
    per_month: ' / mese',
    create: 'Crea licenza',
    no_priced_products:
      'Nessun prodotto ha ancora un prezzo utilizzabile per questo partner — imposta prima il listino prezzi.',
  },
};
